import { useState } from "react";
import SiteLink from "types/SiteLink";
import { SiteLinkTarget } from "types/SiteLinkTarget";
import { SiteLinkDialog } from "./SiteLinkDialog";
import { Link } from "@mui/material";

export interface SiteLinkProps {
    siteLink: SiteLink;
}

export function SiteLinkButton(props: SiteLinkProps) {
    const [showSiteLinkDialog, setShowSiteLinkDialog] = useState(false);

    return (
        <>
            {props.siteLink.target === SiteLinkTarget.Internal && (
                <>
                    <Link
                        color="inherit"
                        href="#"
                        underline="always"
                        onClick={(event) => {
                            event.preventDefault();
                            setShowSiteLinkDialog(true);
                        }}
                    >
                        {props.siteLink.displayName}
                    </Link>

                    {showSiteLinkDialog && (
                        <SiteLinkDialog
                            siteLink={props.siteLink}
                            closeDialog={() => {
                                setShowSiteLinkDialog(false);
                            }}
                        />
                    )}
                </>
            )}
            {props.siteLink.target === SiteLinkTarget.External && (
                <Link
                    color="inherit"
                    href={props.siteLink.url}
                    underline="always"
                    target="_blank"
                    // https://developer.chrome.com/docs/lighthouse/best-practices/external-anchors-use-rel-noopener
                    rel="noopener"
                >
                    {props.siteLink.displayName}
                </Link>
            )}
        </>
    );
}
